import { Outlet, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { useUIStore } from '@/stores/uiStore'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { Sidebar } from './Sidebar'
import { Footer } from './Footer'

export function AdminLayout() {
  const { sidebarCollapsed } = useUIStore()
  const { pathname } = useLocation()

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Sidebar />

      <main
        id="main-content"
        className={cn(
          'flex-1 flex flex-col transition-all duration-200',
          'lg:ml-16',
          !sidebarCollapsed && 'lg:ml-64'
        )}
      >
        <div className="flex-1 p-6">
          {/*
            Boundary sits INSIDE the layout so a page crash costs the operator
            the content area, not the whole panel — sidebar and footer stay
            mounted and usable.

            `key={pathname}` is the other half of that promise. An error
            boundary latches: once `hasError` is true it renders the fallback
            until something resets it, and a route change is not something
            React tells it about. Without the key, one broken page poisoned
            every page the operator visited next — the URL changed, the nav
            responded, and the content area kept showing the old crash until
            they reloaded the tab. Re-keying on the path remounts the boundary
            on navigation, so leaving the broken route is enough to recover.
          */}
          <ErrorBoundary key={pathname}>
            <Outlet />
          </ErrorBoundary>
        </div>
        <Footer />
      </main>
    </div>
  )
}
